import { RootState } from "@/store"

const selectPageStyle = () => (state: RootState) => {
  return state.app.pageStyle
}

const selectIsDevMode = () => (state: RootState) => {
  return state.app.isDevMode
}

const selectIsDesktop = () => (state: RootState) => {
  return state.app.isDesktop
}

const selectLanguage = () => (state: RootState) => {
  return state.app.language
}

const selectIsPhoneDevice = () => (state: RootState) => {
  return state.app.isPhoneDevice
}

const selectIsUnderMaintenance = () => (state: RootState) => {
  return state.app.maintenance.isUnderMaintenance
}

const selectVolume = () => (state: RootState) => {
  return state.app.volume
}

const selectIsTMA = () => (state: RootState) => {
  return state.app.isTMA
}

const selectScreen = () => (state: RootState) => {
  return state.app.screen
}
const selectIsLabrUser = () => (state: RootState) => {
  return state.app.isLabrUser
}

const selectIsLoaded = () => (state: RootState) => {
  return state.app.isLoaded
}

const selectStoreCurrency = () => (state: RootState) => {
  return state.app.storeCurrency
}

const selectIsDevEnv = () => (state: RootState) => {
  return state.app.isDev
}

const selectReAuthState = () => (state: RootState) => {
  return state.app.reAuthState
}

export const AppSelectors = {
  selectPageStyle,
  selectIsDevMode,
  selectIsDesktop,
  selectLanguage,
  selectIsPhoneDevice,
  selectIsUnderMaintenance,
  selectVolume,
  selectIsTMA,
  selectScreen,
  selectIsLabrUser,
  selectIsLoaded,
  selectStoreCurrency,
  selectIsDevEnv,
  selectReAuthState
}
